import request from '@/request'

/**
 * 白皮书资料添加
 * @returns {AxiosPromise}
 */
export function book_modify_material(data) {
  const url = '/api/v1/book/modify_material'
  return request({ url, method: 'POST', data })
}

/**
 * 获取白皮书资料列表
 * @returns {AxiosPromise}
 */
export function getBookMaterial(params) {
  const url = '/api/v1/book/get_material'
  return request({ url, method: 'GET', params })
}

/**
 * 获取白皮书资料列表
 * @returns {AxiosPromise}
 */
export function check_book_material(data) {
  const url = '/api/v1/book/check_material'
  return request({ url, method: 'POST', data })
}

/**
 * 添加白皮书活动
 * @returns {AxiosPromise}
 */
export function modify_active(data) {
  const url = '/api/v1/book/modify_active'
  return request({ url, method: 'POST', data })
}

/**
 * 添加白皮书活动
 * @returns {AxiosPromise}
 */
export function get_active(data) {
  const url = '/api/v1/book/get_active'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书详情
 * @returns {AxiosPromise}
 */
export function getBookDetail(params) {
  const url = '/api/v1/book/get_detail'
  return request({ url, method: 'GET', params })
}

/**
 * 白皮书资料列表
 * @returns {AxiosPromise}
 */
export function getBookList(params) {
  const url = '/api/v1/book/book_list'
  return request({ url, method: 'GET', params })
}

/**
 * 白皮书资料包列表
 * @returns {AxiosPromise}
 */
export function get_package_list(data) {
  const url = '/api/v1/book/get_package_list'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书资料包动态检索
 * @returns {AxiosPromise}
 */
export function search_package_list(data) {
  const url = '/api/v1/book/search_package_list'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书活动成员设置
 * @returns {AxiosPromise}
 */
export function book_create_member(data) {
  const url = '/api/v1/book/create_member'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书生成活动资料包
 * @returns {AxiosPromise}
 */
export function book_modify_package(data) {
  const url = '/api/v1/book/modify_package'
  return request({ url, method: 'POST', data })
}

/**
 * 获取白皮书成员
 * @returns {AxiosPromise}
 */
export function getBookMember(params) {
  const url = '/api/v1/book/get_member'
  return request({ url, method: 'GET', params })
}

/**
 * 获取白皮书成员
 * @returns {AxiosPromise}
 */
export function get_relation(data) {
  const url = '/api/v1/book/get_relation'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书生成二维码
 * @returns {AxiosPromise}
 */
export function create_qr(data) {
  const url = '/api/v1/book/create_qr'
  return request({ url, method: 'POST', data })
}

/**
 * 白皮书详情
 * @param data
 * @returns {AxiosPromise}
 */
export function book_info(data) {
  const url = '/api/v1/book/info'
  return request({ url, method: 'POST', data })
}

/**
 * 检测文件名是否重复
 * @returns {AxiosPromise}
 */
export function material_repeat_name(data) {
  const url = '/api/v1/book/material_repeat'
  return request({ url, method: 'POST', data })
}
